import { render, staticRenderFns } from "./Ref.vue?vue&type=template&id=74607d5e&scoped=true&"
import script from "./Ref.vue?vue&type=script&lang=js&"
export * from "./Ref.vue?vue&type=script&lang=js&"
import style0 from "./Ref.vue?vue&type=style&index=0&id=74607d5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74607d5e",
  null
  
)

export default component.exports